import angular from 'angular';
import uiRouter from 'angular-ui-router';
import companyComponent from './company.component';
import CompanyEdit from './companyEdit/companyEdit';
import CompanyList from './companyList/companyList';
import CompanyService from './company.service';

let companyModule = angular.module('company', [
  uiRouter,
  CompanyEdit,
  CompanyList
])

.component('company', companyComponent)

.service('companyService', CompanyService)

.name;

export default companyModule;



// WEBPACK FOOTER //
// ./client/app/components/company/company.js